import { DefaultPageSkeleton } from '@/components/ui/default-page-skeleton'

export const LicensesPageSkeleton = () => {
  return <DefaultPageSkeleton />
}
